import { useState, useRef } from 'react';
import Overlay from 'react-bootstrap/Overlay';

function StudyTitleCell({ title }) {
  const [show, setShow] = useState(false);
  const target = useRef(null);

  return (
    <>
      <td
        ref={target}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        style={{ cursor: 'default', whiteSpace: 'nowrap' }}
      >
        {title.length > 25 ? title.substring(0, 25) + "..." : title}
      </td>

      <Overlay target={target.current} show={show && title.length > 25} placement="top">
        {({ ...props }) => (
          <div
            {...props}
            style={{
              position: 'absolute',
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              padding: '4px 8px',
              color: 'white',
              borderRadius: 4,
              fontSize: '0.85rem',
              maxWidth: '250px',
              whiteSpace: 'normal',
              zIndex: 9999,
              ...props.style,
            }}
          >
            {title}
          </div>
        )}
      </Overlay>
    </>
  );
}

export default StudyTitleCell;
